import { useMutation, useQuery } from '@apollo/client/react';
import * as compose from 'lodash.flowright';
import { withTranslation } from 'react-i18next';
import { SendPhoneVerificationCode, VerifyPhone } from 'graphqlDocuments/mutations';
import { GetPhoneVerificationInfo } from 'graphqlDocuments/queries';

const PhoneVerificationContainer = (PhoneVerification) =>
  compose(
    withTranslation(['SETTINGS']),
    (Component) =>
      function PhoneVerificationContainerWrapper(props) {
        const phoneVerificationQuery = useQuery(GetPhoneVerificationInfo, {
          fetchPolicy: 'cache-first',
        });
        const [sendPhoneVerificationCodeMutation] = useMutation(SendPhoneVerificationCode);
        const [verifyPhoneMutation] = useMutation(VerifyPhone);
        return (
          <Component
            {...props}
            data={phoneVerificationQuery.data ?? {}}
            loading={phoneVerificationQuery.loading}
            error={phoneVerificationQuery.error}
            sendPhoneVerificationCode={(variables) =>
              sendPhoneVerificationCodeMutation({ variables })
            }
            verifyPhone={(variables) => verifyPhoneMutation({ variables })}
          />
        );
      },
  )(PhoneVerification);

export default PhoneVerificationContainer;
